export default __webpack_public_path__ + "static/media/frontface.8bcf9309.vert";